import { EMPTY, from } from "rxjs";
import { selectSelectedBuildingProduct } from "../../../../selectors/selectExistingBuildingInfo";
import { selectSelectedBuildingNonCollectibleProduct } from "../../../../selectors/selectRecipeInfo";
import { actionModalOpen } from "../../../modals/actionModal";
import { IdModal } from "../../../modals/IdModal";
import { actionQuickSellResourceInfo } from "../../../quick-sell-dialog/actionQuickSell";
export var pathBuildingOpenQuickSell = function (building, state$, deps) {
    var state = state$.value;
    var buildingProducts = selectSelectedBuildingProduct(state);
    var actions = [];
    if (buildingProducts != undefined) {
        var nonCollectibleProduct = selectSelectedBuildingNonCollectibleProduct(state, buildingProducts);
        if (nonCollectibleProduct != undefined) {
            actions.push(actionQuickSellResourceInfo(nonCollectibleProduct));
            actions.push(actionModalOpen(IdModal.QuickSell));
            return from(actions);
        }
    }
    return EMPTY;
};



//////////////////
// WEBPACK FOOTER
// ./src/features/player-base/buildings/path/pathBuildingOpenQuickSell.ts
// module id = 2051
// module chunks = 3